import React from 'react';
import {
    Modal,
} from '@shopify/polaris';
import TagViewComponent from '../components/TagViewComponent';

class ChooseTagsModal extends React.Component {

    state = {
        selectedTags: [],
    };

    constructor(props) {
        super(props);

        this.state = {
            selectedTags: props.selectedTags != null ? props.selectedTags : []
        }
    }

    render() {

        return <Modal sectioned
            open={this.props.active}
            onClose={this.props.onCancel}
            title="Choose tags"
            primaryAction={{
                content: 'Done',
                onAction: this.onDone,
            }}
            secondaryActions={[{
                content: 'Cancel',
                onAction: this.props.onCancel,
            }]}
        >
            <TagViewComponent
                showMarkUnmark={true}
                tags={this.props.tags}
                selectedTags={this.state.selectedTags}
                canSelect={true}
                onSelectedChange={this.handleSelectedTagChange} />
        </Modal>
    }

    onDone = () => {
        this.props.onDone(this.state.selectedTags);
    }

    handleSelectedTagChange = (newSelected) => {
        this.setState({ selectedTags: newSelected });
    }

    componentDidMount() {
    }
}

export default ChooseTagsModal;